import { PluginOptions, POSITION, TYPE } from 'vue-toastification';

export default {
    toastDefaults: {
        [TYPE.ERROR]: { timeout: 8000 },
        [TYPE.SUCCESS]: { timeout: 3000 },
        [TYPE.WARNING]: { timeout: 5000 },
    },
    position: POSITION.BOTTOM_RIGHT,
    timeout: 3000,
    filterBeforeCreate: (toast: any, toasts: any[]) => {
        if (toasts.filter((t) => t.type === toast.type).length !== 0) {
            return false;
        }
        if (toast.type === TYPE.ERROR) {
            toast.toastClassName = 'bg-white text-red-500 border-red-500 border';
            toast.bodyClassName = 'bg-white text-red-500';
        }
        return toast;
    },
} as PluginOptions;
